import React from 'react'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faWrench, faBan } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import axios from 'axios'

import {swalText, language} from '../../../../Constants'

import './service.scss'
import 'sweetalert2/src/sweetalert2.scss'

library.add(faInfo, faWrench, faBan);
export default function Service(props) {
    const {service, change} = props;
    const lang = service.data.find(data => data.language === 'arm');
    return (
        <div className='service' id={`service-${service.id}`}>
            <div className='left'>
                <div className='header'><span><b>Անուն։ </b></span>{lang.name}</div>
                <div className='desc'><span><b>Նկարագրություն։ </b></span>{lang.description}</div>
                <div className='price'><span><b>Գին։ </b></span>{service.price}</div>
            </div>
            <div className='right'>
                <span title='Ջնջել ծառայությունը' onClick={del}><FontAwesomeIcon icon='ban'/></span>
                <span title='Կատարել փոփոխություններ' onClick={upd(service, change)}><FontAwesomeIcon
                    icon='wrench'/></span>
                <span title='Տեսնել ավելին' onClick={showMore(service)}><FontAwesomeIcon icon='info'/></span>
            </div>
        </div>
    )
}

function upd(service, change) {
    return function () {
        Swal.fire({
            type: 'question',
            title: swalText.change,
            confirmButtonText: swalText.yes,
            cancelButtonText: swalText.cancel,
            showCloseButton: true,
            showCancelButton: true,
            html: `
                <div id='serviceInfoTag'>
                   <section>
                        <div><b>${language[0].name}: </b><input type="text" value="${service.data[0].name}" required min='3'></div>
                        <div><b>${language[1].name}: </b><input type="text" value="${service.data[1].name}" required min='3'></div>
                        <div><b>${language[2].name}: </b><input type="text" value="${service.data[2].name}" required min='3'></div>
                    </section>
                    <section>
                        <div><b>${language[0].description}: </b><textarea required>${service.data[0].description}</textarea></div>
                        <div><b>${language[1].description}: </b><textarea required>${service.data[1].description}</textarea></div>
                        <div><b>${language[2].description}: </b><textarea required>${service.data[2].description}</textarea></div>
                    </section>
                    <section><b>Գին: </b><input type="number" min="0" value="${service.price || 0}"></section>
                </div>  
            `
        }).then(result => {
            if (result.value) {
                let id = service.id;
                let tag = document.querySelectorAll('#serviceInfoTag input, #serviceInfoTag  textarea');
                let info = [].map.call(tag, el => el.value.trim());
                info.pop();
                let errors = info.map((el, index) => !el.length && index).filter(el => el !== false);
                let price = tag[6].value;
                if (errors.length) {
                    Swal.fire({
                        type: 'error',
                        title: 'Կիսատ ինֆորմացիա',
                        text: 'Լրացրեք բոլոր դաշտերը'
                    });
                    return;
                }
                axios.post('/api/services/upd', {info, price, id}).then(result => {
                    if (result.data.message === 'Updates completed') {
                        let newService = {
                            id,
                            price,
                            data: []
                        };
                        ['en', 'ru', 'arm'].map((el, index) => {
                            newService.data.push({
                                language: el,
                                name: info[index],
                                description: info[index + 3]
                            })
                        });
                        change(newService);
                    }
                })
            }
        })
    }
}

function showMore(service) {
    return function () {
        Swal.fire({
            type: 'info',
            confirmButtonText: swalText.ok,
            showCloseButton: true,
            html: `
                <div id='serviceInfoTag'>
                   <section>
                        <div><b>${language[0].name}: </b>${service.data[0].name}</div>
                        <div><b>${language[1].name}: </b>${service.data[1].name}</div>
                        <div><b>${language[2].name}: </b>${service.data[2].name}</div>
                        
                    </section>
                    <section>
                        <div><b>${language[0].description}: </b>${service.data[0].description}</div>
                        <div><b>${language[1].description}: </b>${service.data[1].description}</div>
                        <div><b>${language[2].description}: </b>${service.data[2].description}</div>
                    </section>
                </div>  
            `
        })
    }
}

function del(el) {
    let th = el.target;
    Swal.fire({
        type: 'question',
        title: swalText.del,
        text: swalText.delMore,
        confirmButtonText: swalText.yes,
        cancelButtonText: swalText.cancel,
        showCloseButton: true,
        showCancelButton: true
    }).then(result => {
        if (result.value) {
            let tag = th.closest('.service');
            let id = tag.getAttribute('id').split('-')[1];
            axios.delete(`/api/services/delById/${id}`).then(result => {
                if (result.data.message === 'Service deleted') tag.remove();
            })
        }
    })
}
